import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ModalProvider, useModal } from './context/ModalContext';
import MobileBottomNav from './components/layout/MobileBottomNav';

// Pages
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import Resume from './pages/Resume';

// Wrapped App component to access the context
const AppContent = () => {
  const { openContactModal } = useModal();
  // State to manage chatbot visibility
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  
  // Function to open chatbot
  const openChatbot = () => {
    setIsChatbotOpen(true);
  };
  
  // Pass the openChatbot state to all pages
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home isChatbotOpen={isChatbotOpen} setIsChatbotOpen={setIsChatbotOpen} />} />
        <Route path="/projects" element={<Projects isChatbotOpen={isChatbotOpen} setIsChatbotOpen={setIsChatbotOpen} />} />
        <Route path="/about" element={<About isChatbotOpen={isChatbotOpen} setIsChatbotOpen={setIsChatbotOpen} />} />
        <Route path="/resume" element={<Resume isChatbotOpen={isChatbotOpen} setIsChatbotOpen={setIsChatbotOpen} />} />
      </Routes>
      <MobileBottomNav openChatbot={openChatbot} />
    </Router>
  );
};

function App() {
  return (
    <ModalProvider>
      <AppContent />
    </ModalProvider>
  );
}

export default App;